import { useEventsQuery, useExternalReferenceUrl } from 'queries/events';
import { EventFilters, EventStatus, PIparams } from 'queries/events/types';

type useEventsDataProps = {
  filters: EventFilters;
  activeTab?: EventStatus;
};

export const useEventsData = ({ activeTab, filters }: useEventsDataProps) => {
  const { data, refetch, isFetching } = useEventsQuery({
    filters: { status: activeTab, ...filters },
  });

  return { data: data?.events || [], isLoading: isFetching, refetch };
};

export const useExternalReference = (id: string, params: PIparams) => {
  const { data } = useExternalReferenceUrl(id, params);
  return data?.attributes[0]?.value && data?.attributes[0]?.value !== '0'
    ? data?.attributes[0]?.value
    : null;
};
